"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
exports.MainStepper = ({ step, changeMainStep }) => {
    const steps = [
        { number: 1, label: 'Project Initiation' },
        { number: 2, label: 'Preprocessing' },
        { number: 3, label: 'Data Transformation' },
        { number: 4, label: 'Model Tuning' },
        { number: 5, label: 'Model Saving' },
    ];
    const handleClick = (number) => {
        changeMainStep(number);
    };
    return (react_1.default.createElement("div", { style: { display: 'flex', justifyContent: 'center', padding: '20px' } }, steps.map(({ number, label }) => (react_1.default.createElement("div", { key: number, style: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            margin: '0 5px',
            zIndex: '60' / number,
            width: '100%',
        } },
        react_1.default.createElement("div", { style: {
                width: `100%`,
                height: '60px',
                paddingLeft: '20px',
                background: step === number ? 'rgba(42, 123, 236, 0.1)' : '#e0e0e0',
                position: 'relative',
                color: '#000000',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '16px',
                color: step === number ? "#2A7BEC" : "#000000",
                cursor: 'pointer',
            }, onClick: () => handleClick(number) },
            react_1.default.createElement("div", { style: {
                    content: '""',
                    position: 'absolute',
                    left: 0,
                    bottom: 0,
                    width: 0,
                    height: 0,
                    borderLeft: 1 !== number ? '30px solid #F8F8F8' : '0px solid',
                    borderTop: '30px solid transparent',
                    borderBottom: '30px solid transparent',
                } }),
            react_1.default.createElement("div", { style: {
                    content: '""',
                    position: 'absolute',
                    right: '-30px',
                    bottom: 0,
                    width: 0,
                    height: 0,
                    borderLeft: 5 !== number ? step === number ? '30px solid rgba(42, 123, 236, 0.1)' : '30px solid #e0e0e0' : '0px solid',
                    borderTop: '30px solid transparent',
                    borderBottom: '30px solid transparent',
                } }),
            react_1.default.createElement("div", { style: { flex: 1, flexDirection: 'column' } },
                react_1.default.createElement("div", { style: { fontSize: '16px', color: '#005B96' } },
                    "Step 0",
                    number),
                react_1.default.createElement("span", { style: { fontSize: '12px', color: '#555' } }, label))))))));
};
//# sourceMappingURL=main-stepper.js.map